import { LegalPage } from './PublicLayout';

export default function RefundPage() {
    return (
        <LegalPage title="Refund & Cancellation Policy" updated="July 10, 2026" testid="refund-page">
            <p>
                We want you to feel completely comfortable subscribing to Ease My Bill. This policy explains our approach to trials, cancellations, and refunds.
            </p>

            <h2>1. Free trial</h2>
            <ul>
                <li>Every new account gets a <strong>1-month free trial</strong> with full access — no payment upfront.</li>
                <li>You will not be charged during the trial period.</li>
                <li>If you cancel before the trial ends, you will not be charged and your account will move to a limited free state (existing data remains accessible for 90 days).</li>
            </ul>

            <h2>2. 7-day money-back guarantee</h2>
            <ul>
                <li>If you are not satisfied with your <strong>first paid month</strong>, email us at <a href="mailto:support@easemybill.com">support@easemybill.com</a> within <strong>7 days</strong> of the charge for a full refund — no questions asked.</li>
                <li>Refunds are credited back to your original payment method within 5-10 business days by Razorpay.</li>
            </ul>

            <h2>3. Cancellations after the guarantee window</h2>
            <ul>
                <li>You can cancel your subscription any time from Settings → Billing.</li>
                <li>When you cancel, you keep access to Ease My Bill Pro until the end of your current billing period. No further charges are made.</li>
                <li>We do not offer partial or prorated refunds for the unused portion of a monthly cycle, except as required by law.</li>
            </ul>

            <h2>4. Failed payments</h2>
            <ul>
                <li>If a renewal payment fails, Razorpay will retry automatically for up to 4 days.</li>
                <li>If all retries fail, your subscription moves to a <em>past-due</em> state and access is suspended until payment is completed.</li>
                <li>Data is preserved for 90 days from suspension. You can reactivate any time within that window.</li>
            </ul>

            <h2>5. Exceptional refunds</h2>
            <p>Even outside the 7-day window, we may offer refunds at our discretion for:</p>
            <ul>
                <li>Prolonged service outages that materially prevented you from using the app.</li>
                <li>Accidental or duplicate charges.</li>
                <li>Bugs that materially impact core functionality and cannot be resolved in a reasonable time.</li>
            </ul>

            <h2>6. How to request a refund</h2>
            <p>
                Email us at <a href="mailto:support@easemybill.com">support@easemybill.com</a> with:
            </p>
            <ul>
                <li>The email address linked to your Ease My Bill account.</li>
                <li>The Razorpay payment ID (from your receipt email).</li>
                <li>A brief note on the reason.</li>
            </ul>
            <p>We aim to acknowledge refund requests within 2 business days.</p>

            <h2>7. Chargebacks</h2>
            <p>
                Please contact us before initiating a chargeback with your bank. In most cases we can resolve concerns faster than the bank dispute process.
            </p>
        </LegalPage>
    );
}
